module.exports = __webpack_public_path__ + "static/media/robokassa.77cda00b.png";